export default __webpack_public_path__ + "static/media/958.c1b5b0a5.png";